import { useEffect } from "react";
import { Box, Grid } from "@mui/material";
import { SectionWrapper, TitleWrapper, SubtitleWrapper } from "../../../styles/sectionStyles";
import { Education } from "./Education";
import { CertificationContatiners } from "./CertificationContainers";
import Certifications from "../../../data/Certifications.json";
import education from "../../../data/Education.json";
export const EducationContainer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <SectionWrapper>
      <TitleWrapper>Educations</TitleWrapper>
      <Box sx={{marginTop:"20px"}}>
        <Grid container spacing={5}>
          {education.map((edu, ind) => (
            <Grid item xs={12} key={ind}>
              <Education education={edu} ind={ind} />
            </Grid>
          ))}
        </Grid>
      </Box>
      <SubtitleWrapper sx={{marginTop: "30px"}}>Certifications</SubtitleWrapper>
      <Box sx={{marginTop:"20px"}}>
        <CertificationContatiners certficates={Certifications}/>
      </Box>
    </SectionWrapper>
  );
};
